const state = {
  init_status: false,
  error: false,
  department_name: null,
  current_department_id: null,
  current_topic_id: null,
  current_subject_id: null,
  department: {},
  topics: [],
  subjects: [],
  blocks: [],
  quiz_blocks_status: [],
  consultants: []
}

export default state
